import React from "react";
import Tippy from "@tippyjs/react/headless";
import { cls } from "cls";
import Arrow from "~/common/PopupArrow";
import Icon from "~/common/Icons/Standard";
import Button from "~/common/Buttons";
import { sendSocialClickTrackingEvent } from "~/analytics/socialTracking";
interface Props {
  url: string;
  media: string;
  description: string;
}
export default function SocialShareDropdown({
  url,
  media,
  description
}: Props) {
  const pinterestLink = `https://pinterest.com/pin/create/button/?url=${url}&media=${media}&description=${description}`;
  const faceBookLink = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
  const twitterLink = `https://twitter.com/intent/tweet?url=${url}&via=Webstaurant&text=${description}`;
  const handleOnClick = (href: string, height = 400) => (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const popup = window.open(href, "popupwindow", `scrollbars=no,width=800,height=${height}`);
    sendSocialClickTrackingEvent(href, e.currentTarget.innerText, "PDP");
    popup?.focus();
    return false;
  };
  return <Tippy placement="bottom" hideOnClick trigger="click" interactive render={attrs => <div style={{
    top: 5
  }} className={cls("relative", "left-5px")}>
          <div className={cls("bg-clip-padding", "bg-white", "border-black-200", "rounded-md", "border-solid", "border", "hidden", "max-w-full", "p-px", "whitespace-normal", "w-24", "shadow-black-200", "xxs:block")} {...attrs}>
            <div className={cls("px-2")}>
              <ul className={cls("list-none", "m-0")}>
                <li className={cls("group", "mt-1")}>
                  <a href={pinterestLink} onClick={handleOnClick(pinterestLink, 450)} className={cls("group-hover:bg-gray-50", "rounded", "inline-flex", "font-semibold", "text-sm", "py-2", "text-gray-800", "w-full")} data-testid="pinterestButton">
                    <Icon className={cls("h-4", "pr-1", "pl-2", "fill-current", "w-4")} name="pinterest-fill" style={{
                color: "#BD081C"
              }} />
                    Pin it
                  </a>
                </li>
                <li className={cls("group", "mt-1")}>
                  <a className={cls("group-hover:bg-gray-50", "rounded", "inline-flex", "font-semibold", "text-sm", "py-2", "text-gray-800", "w-full")} href={faceBookLink} onClick={handleOnClick(faceBookLink)} data-testid="faceBookButton">
                    <Icon style={{
                color: "#1877F2"
              }} className={cls("h-4", "pr-1", "pl-2", "fill-current", "w-4")} name="facebook-circle" />
                    Share
                  </a>
                </li>
                <li className={cls("group", "mt-1")}>
                  <a href={twitterLink} className={cls("group-hover:bg-gray-50", "rounded", "inline-flex", "font-semibold", "text-sm", "py-2", "text-gray-800", "w-full")} onClick={handleOnClick(twitterLink)} data-testid="twitterButton">
                    <Icon style={{
                color: "#1DA1F2"
              }} className={cls("h-4", "pr-1", "pl-2", "fill-current", "w-4")} name="twitter-fill" />
                    Tweet
                  </a>
                </li>
                <li className={cls("group", "my-1")}>
                  <button type="button" className={cls("bg-transparent", "group-hover:bg-gray-50", "rounded", "border-none", "cursor-pointer", "flex", "items-center", "font-semibold", "text-sm", "py-2", "pl-2", "pr-3", "text-left", "text-gray-800", "w-full")} onClick={() => {
              if (window) {
                window.print();
              }
            }} data-testid="printButton">
                    <Icon className={cls("h-4", "pr-1", "fill-current", "text-green-400", "w-4")} name="printer-fill" />
                    Print
                  </button>
                </li>
              </ul>
            </div>
            {attrs["data-placement"] && <Arrow placement={attrs["data-placement"]} />}
          </div>
        </div>} data-sentry-element="Tippy" data-sentry-component="SocialShareDropdown" data-sentry-source-file="SocialShareDropdown.tsx">
      <Button size="mini" color="glass-outline" className={cls("inline-flex", "items-center", "justify-center", "mr-3")} type="button" data-sentry-element="Button" data-sentry-source-file="SocialShareDropdown.tsx">
        <Icon className={cls("h-4", "pr-1", "align-top", "w-4")} name="share-box" data-sentry-element="Icon" data-sentry-source-file="SocialShareDropdown.tsx" />
        Share
      </Button>
    </Tippy>;
}